// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opportunities-menu[data-v-7a827ad2]{display:flex;flex-direction:column;padding:0}@media (min-width: 1024px){.opportunities-menu[data-v-7a827ad2]{min-width:800px;flex-direction:row}}.extended-block[data-v-7a827ad2]{padding:30px}.extended-block h6[data-v-7a827ad2]{font-size:12px;font-weight:600;margin-bottom:20px;text-transform:uppercase;color:#9096a0}.center-block[data-v-7a827ad2]{width:500px}.user-block[data-v-7a827ad2]{padding:30px;background:#fffae9}\n", ""]);
// Exports
module.exports = exports;
